<script setup>
const openUrl = (url) => {
	if (dataStore.platform === 'web') {
		window.open(url, '_blank')
	} else {
		kettle.openUrl(url)
	}
}
</script>

<template>
	<h4 class="mt-8">Har du spørsmål?</h4>
	<p class="mb-4">Kontakt Opinion sitt supportsenter via e-post eller på telefon. Telefonen er bemannet fra klokken 14:00 på hverdager.</p>
	<div class="profile-actions">
		<button class="action-button" @click="openUrl('mailto:rvu@opinion.no')">
			<i class="fa-solid fa-envelope"></i>
			E-post: <a href="javascript:void(0)">rvu@opinion.no</a>
		</button>
		<button class="action-button" @click="openUrl('tel:+4721300450')">
			<i class="fa-solid fa-phone"></i>
			Telefon: <a href="javascript:void(0)">+47 21 300 450</a>
		</button>
		<button class="action-button" @click="openUrl('https://www.opinion.no/rvu')">
			<i class="fa-solid fa-globe"></i>
			Om RVU: <a href="javascript:void(0)">www.opinion.no/rvu</a>
		</button>
	</div>
</template>
